var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraTutorials4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 306,
    viewBox: "0 0 480 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 480,
    height: 306
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 306,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 24,
    width: 276,
    height: 275
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.459 24.5356L379.111 47.075L356.572 298.722L104.921 276.182L127.459 24.5356Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.567 149.814C369.705 147.263 370.377 144.604 370.616 141.937C371.339 133.862 368.064 125.709 361.417 120.164C340.25 102.502 342.877 106.7 336.648 80.4878C334.047 69.5408 324.389 61.4242 312.775 60.4204C284.935 58.0149 289.634 59.9624 268.593 42.1575C264.198 38.4399 258.815 36.301 253.286 35.8058C247.756 35.3105 242.079 36.4589 237.094 39.3363C213.083 53.1941 218.121 52.0307 190.369 49.457C178.76 48.3808 167.815 54.6521 163.31 64.9627C152.516 89.7074 155.789 86.0111 131.884 99.606C124.358 103.881 119.687 111.323 118.964 119.398C118.725 122.065 118.912 124.801 119.578 127.513C126.002 153.749 126.408 148.872 115.465 173.444C114.327 175.995 113.657 178.649 113.418 181.322C112.695 189.391 115.969 197.549 122.615 203.099C143.734 220.721 141.167 216.527 147.385 242.765C149.985 253.723 159.642 261.834 171.257 262.843C199.097 265.233 194.399 263.305 215.441 281.096C219.835 284.813 225.217 286.958 230.747 287.453C236.276 287.948 241.954 286.794 246.939 283.917C270.798 270.138 265.839 271.222 293.663 273.806C305.271 274.877 316.217 268.612 320.723 258.29C331.521 233.608 328.189 237.274 352.148 223.657C359.674 219.377 364.347 211.931 365.069 203.861C365.309 201.189 365.12 198.457 364.453 195.745C358.02 169.508 357.625 174.382 368.567 149.814Z",
    fill: "#FEE7BE",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.817 28.7242L158.222 29.6719L159.098 23.2607L156.397 19.6604L149.116 25.1239L151.817 28.7242Z",
    fill: "#FBC15C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.195 40.5618L372.392 46.1925L377.983 42.936L379.157 38.5907L370.369 36.2165L369.195 40.5618Z",
    fill: "#FBC15C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.473 248.366L374.67 253.997L380.262 250.74L381.435 246.395L372.647 244.021L371.473 248.366Z",
    fill: "#FBC15C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.632 81.3285L377.455 85.1602L378.267 76.0933L385.632 81.3285Z",
    fill: "#FD9728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9205 65.4833L104.032 54.1436L110.313 65.5308L96.9205 65.4833Z",
    fill: "#FD9728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.773 27.9677L318.962 14.6354L329.728 21.9297L317.773 27.9677Z",
    fill: "#FD9728"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7313 210.298L79.1404 217.526L76.6443 207.426L86.7313 210.298Z",
    fill: "#FD9728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.631 66.104C300.631 64.6332 299.367 63.4802 297.903 63.6144L251.7 67.8496C250.413 67.9675 249.428 69.0468 249.428 70.3391V80.9256C249.428 82.4156 250.724 83.5749 252.205 83.4103L298.407 78.2767C299.673 78.136 300.631 77.0659 300.631 75.792V66.104Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 12.9206,
    height: 12.9206,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 282.671 79.3208)",
    fill: "#E1E1E1",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 12.9206,
    height: 12.9206,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 283.89 79.6377)",
    fill: "white",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.922 85.1811C272.627 85.7139 272.039 86.0157 271.434 85.9448L270.416 85.8253C269.66 85.7367 269.09 85.0964 269.09 84.3355V70.8796C269.09 70.0512 269.762 69.3796 270.59 69.3796H279.119C280.261 69.3796 280.985 70.606 280.432 71.6057L272.922 85.1811Z",
    fill: "#E1E1E1",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.55 84.5164C285.55 85.3156 284.923 85.9744 284.125 86.0145L273.044 86.5709C272.187 86.614 271.469 85.9308 271.469 85.0728V72.3562C271.469 71.5278 272.141 70.8562 272.969 70.8562H284.05C284.878 70.8562 285.55 71.5278 285.55 72.3562V84.5164Z",
    fill: "white",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.335 101.871C345.335 96.5754 341.042 92.2822 335.746 92.2822H160.21C155.792 92.2822 152.21 95.8639 152.21 100.282V234.51H345.335V101.871Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.561 233.807C361.062 238.55 357.049 242.247 352.173 242.247H144.523C139.647 242.247 135.635 238.55 135.135 233.807H361.561Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.884 233.311C268.629 236.55 265.92 239.099 262.616 239.099H237.155C233.85 239.099 231.141 236.55 230.887 233.311H268.884Z",
    fill: "white",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.922 102.563C161.922 101.459 162.817 100.563 163.922 100.563H331.022C332.815 100.563 333.702 102.741 332.42 103.994L209.511 224.12C209.137 224.485 208.635 224.689 208.113 224.689H163.922C162.817 224.689 161.922 223.794 161.922 222.689V102.563Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.77 145.805V224.688H255.306L334.77 145.805Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.802 102.959C335.802 102.131 335.13 101.459 334.302 101.459H163.285C162.457 101.459 161.785 102.131 161.785 102.959V224.758C161.785 225.586 162.457 226.258 163.285 226.258H334.302C335.13 226.258 335.802 225.586 335.802 224.758V102.959Z",
    stroke: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.45135,
    transform: "matrix(-1 0 0 1 250.377 97.3732)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 33.412,
    y2: -0.75,
    transform: "matrix(0.706141 -0.708071 0.706141 0.708071 170.042 190.876)",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 19.7472,
    y2: -0.75,
    transform: "matrix(0.706141 -0.708071 0.706141 0.708071 172.936 201.52)",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.327 162.812L249.496 145.805L232.685 162.812V179.446H266.327V162.812Z",
    fill: "#FCC35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.327 179.456L248.926 187.566V171.325L266.327 179.456Z",
    fill: "#FD9728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.072 66.4405C301.072 65.2602 300.055 64.3366 298.88 64.4497L252.998 68.8652C251.972 68.9639 251.189 69.8256 251.189 70.856V81.728C251.189 82.919 252.224 83.8461 253.408 83.716L299.29 78.6767C300.304 78.5654 301.072 77.7088 301.072 76.6887V66.4405Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.335 72.8318C274.051 75.8963 275.948 78.441 278.402 78.6682C280.857 78.8953 283.189 76.7422 283.473 73.6777C283.756 70.6132 281.859 68.0685 279.405 67.8414C276.951 67.6142 274.618 69.7673 274.335 72.8318Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.715 73.1418C277.658 73.7568 277.775 74.3065 277.985 74.6951C278.197 75.0873 278.469 75.2646 278.717 75.2876C278.965 75.3106 279.265 75.1861 279.545 74.8395C279.823 74.4961 280.04 73.9773 280.097 73.3623C280.154 72.7473 280.036 72.1976 279.826 71.809C279.614 71.4168 279.342 71.2395 279.094 71.2165C278.846 71.1936 278.546 71.318 278.266 71.6646C277.988 72.008 277.772 72.5268 277.715 73.1418Z",
    fill: "#FCC35D",
    stroke: "#FCC35D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.686 64.1225C243.338 66.5737 241.987 68.4157 242.26 73.6648",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.928 64.5807C238.655 67.3189 237.797 69.17 238.361 73.7136",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraTutorials4);
export default __webpack_public_path__ + "static/media/camera-tutorials-4.670dbfdf.svg";
export { ForwardRef as ReactComponent };